import React, { useState } from "react";
import ProfileHeader from "./ProfileHeader";
import BasicNavbar from "./../Navbar/BasicNavbar";
import { ActiveTab } from "../../types/activeTabs";
import Revenues from "./Revenues";
import EnrolledCourses from "./EnrolledCourses";
import { useParams } from "react-router-dom";
import UserProfile from "./UserProfile";
import { useCookies } from "react-cookie";

const Profile = () => {
    const [activeTab, setActiveTab] = useState<ActiveTab>(ActiveTab.Profile); // Set initial state using enum
    const { id } = useParams();
    const [cookies, setCookie, removeCookie] = useCookies(['user-data', "token"]);
    const renderTabContent = () => {
        switch (activeTab) {
            case ActiveTab.Profile:
                return <UserProfile />;
            case ActiveTab.Revenues:
                return <Revenues />;
            case ActiveTab.EnrolledCourses:
                return <EnrolledCourses  />;
            default:
                return <UserProfile />;
        }
    };

    return (
        <div>
            <BasicNavbar />
            {cookies["user-data"].id == id ?
                <ProfileHeader ProfileSetActiveTab={setActiveTab} /> : ""}

            <div className="mt-4">{renderTabContent()}</div>
        </div>
    );
};

export default Profile;
